import { render, staticRenderFns } from "./MediaFileItem.vue?vue&type=template&id=60d43f72&scoped=true&"
import script from "./MediaFileItem.vue?vue&type=script&lang=ts&"
export * from "./MediaFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaFileItem.vue?vue&type=style&index=0&id=60d43f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d43f72",
  null
  
)

export default component.exports